import { SaveReportRequestParams, useFiltersStore } from '@/hooks'
import { useSustainabilityFiltersStore } from './useSustainabilityFiltersStore'
import { mapSustainabilityFiltersSaveParams } from '../utils/mapSustainabilityFiltersSaveParams'
import { useMemo } from 'react'

export const useSustainabilityFiltersSaveParams = () => {
    const activeSustainabilityFilters = useSustainabilityFiltersStore(
        (state) => state.activeFilters
    )

    const rootNode = useFiltersStore((state) => state.rootNode)

    const sustainabilityFiltersParams: SaveReportRequestParams = useMemo(() => {
        const passedFilters = Object.assign({}, activeSustainabilityFilters)

        if (!passedFilters.node.length && rootNode) {
            passedFilters.node = [rootNode.nodeId]
        }

        return mapSustainabilityFiltersSaveParams(passedFilters)
    }, [activeSustainabilityFilters, rootNode])

    return sustainabilityFiltersParams
}
